"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Office = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Office = function Office() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.454 19.778h-3.818V3.11c0-.614-.488-1.111-1.09-1.111H5.455c-.603 0-1.091.497-1.091 1.111v16.667H.545a.55.55 0 00-.545.555v1.111A.55.55 0 00.545 22h22.91a.55.55 0 00.545-.556v-1.11a.55.55 0 00-.546-.556zm-6.545-8.89h-1.09a.55.55 0 01-.546-.555v-1.11a.55.55 0 01.545-.556h1.091a.55.55 0 01.546.555v1.111a.55.55 0 01-.546.556zm-9.818 0h1.09a.55.55 0 00.546-.555v-1.11a.55.55 0 00-.545-.556H7.09a.55.55 0 00-.546.555v1.111a.55.55 0 00.546.556zm1.636 2.779v1.11a.55.55 0 01-.545.556H7.09a.55.55 0 01-.546-.555v-1.111a.55.55 0 01.546-.556h1.09a.55.55 0 01.546.556zm8.182-.556h-1.09a.55.55 0 00-.546.556v1.11a.55.55 0 00.545.556h1.091a.55.55 0 00.546-.555v-1.111a.55.55 0 00-.546-.556zm0-6.666h-1.09a.55.55 0 01-.546-.556V4.778a.55.55 0 01.545-.556h1.091a.55.55 0 01.546.556v1.111a.55.55 0 01-.546.556zm-8.182-.556V4.778a.55.55 0 00-.545-.556H7.09a.55.55 0 00-.546.556v1.111a.55.55 0 00.546.556h1.09a.55.55 0 00.546-.556zM7.091 17.555h9.818a.55.55 0 01.546.556v1.667H6.545V18.11a.55.55 0 01.546-.556zm4.364-6.666h1.09a.55.55 0 00.546-.556v-1.11a.55.55 0 00-.545-.556h-1.091a.55.55 0 00-.546.555v1.111a.55.55 0 00.546.556zm0 2.222h1.09a.55.55 0 01.546.556v1.11a.55.55 0 01-.545.556h-1.091a.55.55 0 01-.546-.555v-1.111a.55.55 0 01.546-.556zm0-6.666h1.09a.55.55 0 00.546-.556V4.778a.55.55 0 00-.545-.556h-1.091a.55.55 0 00-.546.556v1.111a.55.55 0 00.546.556z",
    clipRule: "evenodd"
  });
};

exports.Office = Office;